import { getAll as getAllProduitDivers } from '@/api/produit/produitDivers';
import { getAll as getAllProduitLocation } from '@/api/produit/produitLocation';
import { getAll as getAllProduit } from '@/api/produit/index';
import { get as getProduitPresse } from '@/api/produit/produitPresse';
import { get as getProduitSponsoring } from '@/api/produit/produitSponsoring';
import { get as getProduitSalon } from '@/api/produit/produitSalon';
import { get as getProduitAutre } from '@/api/produit/produitAutre';
import * as produitConf from '@/configuration/catalogue/produitConf';
import store from '@/store/store';
import getAgenceId from '@/services/general/getSocieteId';
import { NO_PAGINATION } from '@/configuration/clientTableConf';

function getLiaisonsTarifWithSocieteActiveId(liaisons) {
  const societeId = store.getters['societe/societeActiveId'];
  const liaisonsTarifs = liaisons.filter((liaison) => {
    return liaison.produitEnfant.supportCommercial.societeId === societeId;
  });
  return liaisonsTarifs;
}

function triLocation(produitsLibelleLocation) {
  produitsLibelleLocation.sort((a, b) => {
    if (a.estParent && !b.estParent) {
      return -1;
    }
    if (a.estParent && b.estParent) {
      return a.libelle.localeCompare(b.libelle);
    }
    return 1;
  });
}

function getAdresse(produit, type) {
  switch (type) {
    case produitConf.CATEGORIE_UNITAIRE:
      return produit.produitFace.adresse;
    case produitConf.CATEGORIE_REGROUPEMENT:
    case produitConf.CATEGORIE_REGROUPEMENT_LC:
    case produitConf.CATEGORIE_REGROUPEMENT_MAIRIE:
      return produit.produitReseau.adresse;
    case produitConf.CATEGORIE_ECRAN_NUMERIQUE:
      return produit.produitEcranNumerique.adresse;
    case produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE:
      return produit.produitReseauNumerique.adresse;
    default: return null;
  }
}
function traitementReponseProduits(donnesProduitBrut, type, getLiaisonTarifEnfant) {
  const donneesProduit = [];
  donnesProduitBrut.forEach((produit) => {
    if (produit.liaisonsTarif.length === 0 || !getLiaisonTarifEnfant) {
      donneesProduit.push(
        {
          id: produit.id,
          reference: produit.reference,
          libelle: '',
          title: produit.reference + ' - ' + produit.libelle,
          idProduitEnfant: null,
          type: type,
          produit: produit,
          estParent: false,
          adresse: getAdresse(produit, type),
        },
      );
    }
    if (!getLiaisonTarifEnfant) return;
    produit.liaisonsTarif.forEach((liaisonsTarif) => {
      if (donneesProduit.some(p => {
        return p.id === produit.id && p.idProduitEnfant === liaisonsTarif.produitEnfantId;
      })) {
        return;
      }
      donneesProduit.push(
        {
          id: produit.id,
          reference: produit.reference,
          libelle: liaisonsTarif.libelle,
          title: produit.reference + ' - ' + produit.libelle,
          titleEnfant: liaisonsTarif.libelle,
          idProduitEnfant: liaisonsTarif.produitEnfantId,
          type: type,
          produit: produit,
          estParent: liaisonsTarif.estParent,
          adresse: getAdresse(produit, type),
        },
      );
    });
  });
  triLocation(donneesProduit);
  return donneesProduit;
}

function donneProduitsLocation(produitsbase) {
  let retour = [];
  const produitsLocation = produitsbase.filter(produit => {
    return produit.supportCommercial.categorieVente === produitConf.CATEGORIE_LOCATION;
  });
  if (produitsLocation.length === 0) {
    return retour;
  }
  produitsLocation.forEach((location) => {
    location.liaisonsTarif = getLiaisonsTarifWithSocieteActiveId(location.liaisonsTarif);
  });
  const locationsPapier = produitsLocation.filter(location => {
    return !location.numerique;
  });
  if (locationsPapier.length > 0) {
    retour.push({ title: 'catalogue.productType.location' });
    retour = retour.concat(traitementReponseProduits(
      locationsPapier, produitConf.CATEGORIE_LOCATION, false,
    ));
  }

  const locationsNumerique = produitsLocation.filter(location => {
    return location.numerique;
  });
  if (locationsNumerique.length > 0) {
    retour.push({ title: 'catalogue.productType.locationNumerique' });
    retour = retour.concat(traitementReponseProduits(
      locationsNumerique, produitConf.CATEGORIE_LOCATION, true,
    ));
  }
  return retour;
}

function getProductAndTitle(produitsbase, title, type) {
  let retour = [];
  const produits = produitsbase.filter(produit => {
    return produit.supportCommercial.categorieVente === type;
  });
  produits.forEach((produit) => {
    produit.liaisonsTarif = getLiaisonsTarifWithSocieteActiveId(produit.liaisonsTarif);
  });
  if (produits.length === 0) {
    return retour;
  }
  retour.push({ title: title });
  retour = retour.concat(traitementReponseProduits(produits, type, true));
  return retour;
}

export async function getAllProduct(search, categories, sens, societeId, filtreProduitParSociete,
  filtreProduitParSecteur) {
  let donneesProduits = [];
  const agencesId = await getAgenceId();
  const payload = {
    query: {
      auto: search,
      nonCommercialisable: false,
      proposableLc: true,
      sens: sens,
      societeId: filtreProduitParSociete ? societeId : null,
      societeIdLocAndDivers: !filtreProduitParSociete ? societeId : null,
      agencesId,
      secteurIds:
        filtreProduitParSecteur != null && filtreProduitParSecteur.length > 0
          ? filtreProduitParSecteur : null,
    },
    limit: NO_PAGINATION,
  };
  if (categories && categories.length > 0) {
    payload.query.categorie = categories;
  }
  const response = (await getAllProduit(payload)).data.result;
  if (response.totalCount === 0) {
    return donneesProduits;
  }

  if (search.toUpperCase().startsWith('LOC')) {
    donneesProduits = donneesProduits.concat(donneProduitsLocation(response.items));
  }
  donneesProduits = donneesProduits.concat(getProductAndTitle(response.items, 'catalogue.productType.face', produitConf.CATEGORIE_UNITAIRE));
  donneesProduits = donneesProduits.concat(getProductAndTitle(response.items, 'catalogue.productType.reseauTempo', produitConf.CATEGORIE_REGROUPEMENT));
  donneesProduits = donneesProduits.concat(getProductAndTitle(response.items, 'catalogue.productType.reseauLc', produitConf.CATEGORIE_REGROUPEMENT_LC));
  donneesProduits = donneesProduits.concat(getProductAndTitle(response.items, 'catalogue.productType.reseauMairie', produitConf.CATEGORIE_REGROUPEMENT_MAIRIE));
  donneesProduits = donneesProduits.concat(getProductAndTitle(response.items, 'catalogue.productType.reseauNumerique', produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE));
  donneesProduits = donneesProduits.concat(getProductAndTitle(response.items, 'catalogue.productType.produitNumerique', produitConf.CATEGORIE_ECRAN_NUMERIQUE));
  donneesProduits = donneesProduits.concat(getProductAndTitle(response.items, 'catalogue.productType.salon', produitConf.CATEGORIE_SALON));
  donneesProduits = donneesProduits.concat(getProductAndTitle(response.items, 'catalogue.productType.sponsoring', produitConf.CATEGORIE_SPONSORING));
  donneesProduits = donneesProduits.concat(getProductAndTitle(response.items, 'catalogue.productType.autre', produitConf.CATEGORIE_AUTRE));
  donneesProduits = donneesProduits.concat(getProductAndTitle(response.items, 'catalogue.productType.presse', produitConf.CATEGORIE_PRESSE));
  donneesProduits = donneesProduits.concat(getProductAndTitle(response.items, 'catalogue.productType.dispositif', produitConf.CATEGORIE_DISPOSITIF));
  donneesProduits = donneesProduits.concat(getProductAndTitle(response.items, 'catalogue.productType.impressionAffiche', produitConf.CATEGORIE_IMPRESSION_AFFICHE));
  if (!search.toUpperCase().startsWith('LOC')) {
    donneesProduits = donneesProduits.concat(donneProduitsLocation(response.items));
  }
  donneesProduits = donneesProduits.concat(getProductAndTitle(response.items, 'catalogue.productType.various', produitConf.CATEGORIE_DIVERS));
  return donneesProduits;
}

export async function getAllProductDiversLocation(search, categories, societeId, sens) {
  let donneesProduits = [];
  const payload = {
    query: { auto: search, sens: sens, societeId: societeId },
    limit: NO_PAGINATION,
  };
  if (categories && categories.length > 0) {
    payload.query.categorie = categories;
  }
  const response = (await getAllProduit(payload)).data.result;
  if (response.totalCount === 0) {
    return donneesProduits;
  }
  donneesProduits = donneesProduits.concat(donneProduitsLocation(response.items));
  donneesProduits = donneesProduits.concat(getProductAndTitle(response.items, 'catalogue.productType.various', produitConf.CATEGORIE_DIVERS));
  donneesProduits = donneesProduits.concat(getProductAndTitle(response.items, 'catalogue.productType.dispositif', produitConf.CATEGORIE_DISPOSITIF));
  return donneesProduits;
}

export async function getAllProductDivers(search, societeId) {
  let donneesProduitsDivers = [];
  const response = await getAllProduitDivers({
    query: {
      auto: search,
      societeId,
    },
    limit: NO_PAGINATION,
  });
  if (response.data.result.totalCount > 0) {
    donneesProduitsDivers = traitementReponseProduits(
      response.data.result.items, produitConf.CATEGORIE_DIVERS, false,
    );
  }
  return donneesProduitsDivers;
}

export async function getAllProductLocation(search, societeId) {
  let donneesProduitsLocation = [];
  const response = await getAllProduitLocation({
    query: {
      auto: search,
      societeId,
    },
    limit: NO_PAGINATION,
  });
  if (response.data.result.totalCount > 0) {
    donneesProduitsLocation = traitementReponseProduits(
      response.data.result.items, produitConf.CATEGORIE_LOCATION, false,
    );
  }
  return donneesProduitsLocation;
}

export async function getAllProduitSalon(auto, ligneRegroupement) {
  const produit = (await getProduitSalon(ligneRegroupement.produit.id)).data.result;
  const donnees = [];
  const prestationsFilter = produit.produitSalon.prestations.filter(item => {
    let search = false;
    [
      item.libelle,
      item.reference,
    ].forEach((itemSearch) => {
      if (itemSearch
        && itemSearch.toLowerCase().includes(auto.toLowerCase())) {
        search = true;
      }
    });
    return search;
  });
  if (prestationsFilter.length > 0) {
    prestationsFilter.forEach(prestation => {
      donnees.push({
        id: prestation.id,
        reference: prestation.reference,
        libelle: prestation.libelle,
        title: prestation.reference + ' - ' + prestation.libelle,
        idProduitEnfant: null,
        type: produitConf.CATEGORIE_PRESTATION,
        produit: {
          produitPrestation: prestation,
          reference: prestation.reference,
        },
        estParent: false,
        adresse: null,
      });
    });
  }
  return donnees;
}

export async function getAllProduitEncart(auto, ligneRegroupement) {
  const produit = (await getProduitPresse(ligneRegroupement.produit.id)).data.result;
  const donnees = [];
  const encartsFilter = produit.produitPresse.encarts.filter(item => {
    let search = false;
    [
      item.libelle,
      item.reference,
    ].forEach((itemSearch) => {
      if (itemSearch
        && itemSearch.toLowerCase().includes(auto.toLowerCase())) {
        search = true;
      }
    });
    return search;
  });
  if (encartsFilter.length > 0) {
    encartsFilter.forEach(encart => {
      donnees.push({
        id: encart.id,
        reference: encart.reference,
        libelle: encart.libelle,
        title: encart.reference + ' - ' + encart.libelle,
        idProduitEnfant: null,
        type: produitConf.CATEGORIE_ENCART,
        produit: {
          produitEncart: encart,
          reference: encart.reference,
        },
        estParent: false,
        adresse: null,
      });
    });
  }
  return donnees;
}

export async function getAllProduitForPrestation(auto, ligneRegroupement, typeProduit) {
  let prestations = [];
  switch (typeProduit) {
    case produitConf.CATEGORIE_SPONSORING:
      prestations = (await getProduitSponsoring(ligneRegroupement.produit.id))
        .data.result.produitSponsoring.prestations;
      break;
    case produitConf.CATEGORIE_AUTRE:
      prestations = (await getProduitAutre(ligneRegroupement.produit.id))
        .data.result.produitAutre.prestations;
      break;
    default:
      break;
  }
  const prestationsFilter = prestations.filter(item => {
    return [item.libelle, item.reference]
      .filter(Boolean).join().toLowerCase().includes(auto.toLowerCase());
  });
  return prestationsFilter.map(prestation => ({
    id: prestation.id,
    reference: prestation.reference,
    libelle: prestation.libelle,
    title: prestation.reference + ' - ' + prestation.libelle,
    idProduitEnfant: null,
    type: produitConf.CATEGORIE_PRESTATION,
    produit: {
      produitPrestation: prestation,
      reference: prestation.reference,
    },
    estParent: false,
    adresse: null,
  }));
}

export function getAllProduitAutre(auto, ligneRegroupement) {
  return getAllProduitForPrestation(auto, ligneRegroupement, produitConf.CATEGORIE_AUTRE);
}

export function getAllProduitSponsoring(auto, ligneRegroupement) {
  return getAllProduitForPrestation(auto, ligneRegroupement, produitConf.CATEGORIE_SPONSORING);
}
